import * as persistanceKeys from '@web-platform/shared-universal-constants/src/persistanceKeys';
import { SEARCH_PARAMS_CHANGED } from '@web-platform/shared-universal-constants/src/userSearch';
import { tryGetValue } from '@web-platform/shared-universal-utils-frontend/src/helpers/sessionStorage';
import mapValues from 'lodash/mapValues';

import {
  ALLIANCE_FILTER_CHANGED,
  CARRIERS_FILTER_CHANGED,
  CARRIER_CONTROL_FILTER_CHANGED,
  FILTERS_RESET,
} from '../../../../../../actions/filters';

import type { Action } from '@web-platform/shared-universal-types/src/redux/banana/actions/actions-banana-types';
import type { AlliancesFilterState } from '@web-platform/shared-universal-types/src/redux/state/flightSearchResults/features/filters/alliances';
import type { FiltersState } from '@web-platform/shared-universal-types/src/redux/state/flightSearchResults/features/filters/state';

export const INITIAL_STATE: AlliancesFilterState = {};
const filtersInSession = (): FiltersState =>
  // @ts-expect-error FiltersState type is not compatible with empty object
  tryGetValue(persistanceKeys.FILTERS, INITIAL_STATE);
const storedStateFilters = () => filtersInSession()?.alliances ?? INITIAL_STATE;

export const createAlliancesReducer =
  (getInitialState: () => AlliancesFilterState = storedStateFilters) =>
  (state: AlliancesFilterState = getInitialState(), action: Action): AlliancesFilterState => {
    switch (action.type) {
      case ALLIANCE_FILTER_CHANGED:
        return {
          ...state,
          [action.payload.name]: {
            value: action.payload.value,
          },
        };

      case FILTERS_RESET:
      case CARRIER_CONTROL_FILTER_CHANGED:
      case CARRIERS_FILTER_CHANGED: {
        return mapValues(state, (alliance) => ({ ...alliance, value: false }));
      }

      case SEARCH_PARAMS_CHANGED:
        return state;

      default:
        return state;
    }
  };

export const get = (state: AlliancesFilterState): AlliancesFilterState => state;
export default createAlliancesReducer();
